export default function RoundDivider({
    expanded, 
    roundIndex 
}) {

    if (expanded === false) {
        return null
    }

    return (
        <div className='w-full px-4 py-2 bg-white'>
            <p className='font-bold text-gray-600 select-none'>Round {roundIndex + 1}</p>
        </div>
    )
}